import React from 'react';
export function ArrowUpIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M12.782 7.098L13 21.5h-2l.218-14.402-6.036 5.633-1.364-1.462L12 3.632l8.182 7.637-1.364 1.462-6.036-5.633z"
  }));
}